<template>
    <div>
        <v-card color="#fbf8f8" class="px-2">
            <v-card-title class="headline">Nomencladores:</v-card-title>
            <v-divider></v-divider>

            <v-card-text class="pa-0 px-1">
                <v-container grid-list-xl fluid class="px-1 py-3">
                    <v-layout row wrap>
                        <template v-for="(option, index) in options">
                            <v-flex sm4 :key="`flex-${index}`" class="pa-1" @click="applyAction(option)">
                                <v-card :key="`card-${index}`" class="text-xs-center card-info">
                                    <v-card-text class="pa-0">
                                        <v-icon x-large>{{ option.icon }}</v-icon>
                                    </v-card-text>
                                    <v-card-text class="pt-0 px-1 pb-2">
                                        <v-btn small flat round outline dark color="blue" class="ma-0">{{
                                            option.text
                                        }}</v-btn>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </template>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    name: "CardInfoNomencladores",
    props: {
        options: { type: Array, default: null }
    },
    data() {
        return {}
    },
    methods: {
        applyAction(option) {
            this.$emit("closeMenu")
            this.$router.push({ name: option.value })
        }
    },
    computed: {}
}
</script>

<style>
.card-info {
    margin-left: 1px;
    margin-right: 1px;
    border-radius: 6px;
    transition: background-color 700ms;
}
.card-info:hover {
    background-color: #a4cedf;
    cursor: pointer;
}
</style>
